export const common = {
	//Menu
	"menu.play": "Jouer",
	"menu.ranking": "Classement",
	"menu.prizes": "Prix",
	"menu.rules": "Règles",
	"menu.leagues": "Ligues",
	"menu.betwayAccount": "Compte Betway",
	"menu.terms": "CGU",

	//Play
	"play.heroTitle": "Prédisez chaque résultat de match et gagnez des prix !",
	"play.heroSubtitle": "Quelle équipe va gagner ? Combien de buts vont-ils marquer ? Prédisez maintenant et affrontez vos amis !",
	"play.playNow": "Jouer maintenant",
	"play.seePrizes": "Voir les prix",
	"play.statistics": "Statistiques",
	"play.lastMatches": "Les 5 derniers matchs de chaque équipe",
	"play.stats": "Stats",

	//Ranking
	"ranking.season": "Saison",
	"ranking.weekly": "Hebdomadaire",
	"ranking.selectType": "Sélectionner le type de classement",
	"ranking.selectWeek": "Sélectionner la semaine",
	"ranking.myPosition": "Ma position",
	"ranking.points": "Points",
	"ranking.rank": "Rang",
	"ranking.topMembers": "Top 20 des membres",
	"ranking.noRanking": "Pas encore de classement.",
	"ranking.competitionStart": "Une fois la compétition commencée, tous les utilisateurs qui ont joué à Score Predict seront classés ici.",
	"ranking.loadMore": "Charger Plus",
	"ranking.loading": "Chargement...",

	//Leagues
	"leagues.heroTitle": "Affrontez vos amis ou rejoignez des ligues publiques !",
	"leagues.heroSubtitle": "Qui a les meilleures compétences de prédiction ? Créez ou rejoignez une ligue pour le découvrir !",
	"leagues.createLeague": "Créer une ligue",
	"leagues.joinLeague": "Rejoindre une ligue",
	"leagues.createLeagueButton": "Créer une ligue",
	"leagues.joinLeagueButton": "Rejoindre une ligue",
	"leagues.enterName": "Entrer le nom de la ligue",
	"leagues.enterCode": "Entrer le code d'invitation",
	"leagues.myLeagues": "Mes ligues",
	"leagues.member": "membre",
	"leagues.members": "membres",
	"leagues.membersCapital": "Membres",
	"leagues.league": "Ligue",
	"leagues.shareCodeText": "Vos amis peuvent rejoindre votre ligue en utilisant ce code :",
	"leagues.shareCode": "Partager le code",
	"leagues.editLeague": "Modifier la ligue",
	"leagues.delete": "Supprimer",
	"leagues.leave": "Quitter",
	"leagues.deleteWarning": "Tout l'historique et les membres seront définitivement supprimés.",
	"leagues.leaveWarning": "Vos points de prédiction et votre classement seront supprimés.",
	"leagues.confirmDelete": "Oui, supprimer",
	"leagues.confirmLeave": "Oui, quitter",
	"leagues.cancel": "Annuler",
	"leagues.ban": "Bannir",
	"leagues.edit": "Modifier",
	"leagues.save": "Sauvegarder",

	//Errors
	"errors.savingPredictions": "Erreur lors de la sauvegarde des prédictions",

	//Predictions
	"predictions.successModal.title": "Prédictions confirmées !",
	"predictions.successModal.subtitle": "Vos prédictions ont été sauvegardées avec succès !",
	"predictions.successModal.close": "Fermer",
	"predictions.seasonEnd.title": "Saison terminée !",
	"predictions.seasonEnd.message":
		"C'est fini pour cette saison de BW ScorePredict — bien joué ! Félicitations à notre grand gagnant, [username], qui a remporté un voyage pour deux personnes pour voir Arsenal en direct à l'Emirates Stadium. Pendant que l'action fait une courte pause, nous nous préparons déjà pour le prochain tour. Restez à l'écoute pour les mises à jour et préparez-vous à revenir avec des prédictions encore plus précises.",
	"predictions.seasonEnd.subtitle": "Nous avons hâte de vous revoir dans le jeu !",
	"predictions.seasonEnd.myPosition": "Ma position",
	"predictions.seasonEnd.points": "Points",
	"predictions.seasonEnd.rank": "Rang",
	"predictions.seasonEnd.topMembers": "Top 10 des membres",
	"predictions.countdown.deadline": "Date limite",
	"predictions.countdown.deadlineMissed": "Date limite manquée",
	"predictions.countdown.matchweekDeadline": "Date limite de la journée",
	"predictions.countdown.deadlineMissedMessage":
		"Vous n'avez pas fait vos prédictions pour cette semaine, donc aucun point n'a été gagné - mais il y a toujours la semaine prochaine pour rebondir !",
	"predictions.countdown.days": "JOURS",
	"predictions.countdown.hours": "HEURES",
	"predictions.countdown.minutes": "MIN.",
	"predictions.countdown.seconds": "SEC.",
	"predictions.bonusFooter.loadingOdds": "Chargement des cotes...",
	"predictions.bonusFooter.draw": "Match nul",
	"predictions.bonusFooter.unknown": "Inconnu",
	"predictions.bonusFooter.oddsToWin": "Cotes de victoire",
	"predictions.roundSelector.previousRound": "Tour précédent",
	"predictions.roundSelector.nextRound": "Tour suivant",
	"predictions.points.totalPoints": "Points totaux",
	"predictions.points.currentPosition": "Position actuelle",
	"predictions.points.points": "Points",
	"predictions.points.totalPointsLabel": "Points totaux",
	"predictions.submitButton.submitting": "Envoi en cours...",
	"predictions.submitButton.predictionsSaved": "Prédictions sauvegardées",
	"predictions.submitButton.updatePredictions": "Mettre à jour les prédictions",
	"predictions.submitButton.submitAllPredictions": "Soumettre toutes les prédictions",
	"predictions.predictionCard.result": "Résultat",
	"predictions.predictionCard.pts": "Pts",

	//Predictions Info Card
	"predictions.infoCard.title": "Prédisez chaque résultat de match et gagnez des prix !",
	"predictions.infoCard.description":
		"Qui va l'emporter ? Combien de buts vont-ils marquer ? Prédisez maintenant et affrontez vos amis ! Les règles et conditions générales s'appliquent.",
	"predictions.infoCard.playButton": "Jouer maintenant",
	"predictions.infoCard.prizesButton": "Voir les prix",

	//Common Components
	"common.shareCard.title": "Invitez vos amis à jouer",
	"common.shareCard.description":
		"Invitez vos amis à jouer à BW ScorePredict pour voir qui de vous est le meilleur manager de football, et pour que vous ayez tous une chance de gagner des prix hebdomadaires !",
	"common.shareCard.button": "Inviter des amis",
	"common.shareCard.shareTitle": "Télécharger BetwayScores",
	"common.shareCard.shareBody": "Téléchargez BetwayScores et affrontez vos amis dans BW ScorePredict !",

	"common.accessDenied.title": "Télécharger l'app Betway Scores",
	"common.accessDenied.description":
		"Pour accéder à ce contenu, veuillez télécharger l'application Betway Scores. Obtenez les derniers scores, prédictions et fonctionnalités exclusives à portée de main.",
	"common.accessDenied.rulesText": "Disponible pour les appareils iOS et Android. Téléchargez maintenant pour commencer !",
	"common.accessDenied.button": "Télécharger l'app Betway Scores",

	"common.prizesInfoCard.title": "Informations sur les prix",
	"common.prizesInfoCard.description1":
		"Vous n'avez pas besoin d'avoir un compte Betway pour jouer à BW ScorePredict, cependant pour récupérer un prix hebdomadaire en finissant dans le Top 10 d'une semaine, vous devez avoir un compte Betway pour que ces gains y soient déposés.",
	"common.prizesInfoCard.description2": "Voir les Règles et CGU du jeu pour les détails des prix hebdomadaires et globaux.",
	"common.prizesInfoCard.button": "Voir les règles",

	//Prizes Fragment
	"prizes.prizeCard1.title": "Grand Prix – Regarder Arsenal à l'Emirates Stadium",
	"prizes.prizeCard1.description":
		"Gagnez un voyage pour deux personnes pour voir Arsenal jouer à l'Emirates Stadium à Londres, incluant les vols (si nécessaire), l'hébergement (si nécessaire) et £500 d'argent de poche.",
	"prizes.prizeCard2.title": "Gagnant du tour – Prix en espèces dans votre compte Betway",
	"prizes.prizeCard2.description":
		"Le meilleur performeur chaque semaine gagnera €150 (ou équivalent en devise – voir section 'Règles') en espèces déposé dans son compte Betway.",
	"prizes.prizeCard3.title": "Places 2-10 chaque tour – Prix en espèces dans votre compte Betway",
	"prizes.prizeCard3.description":
		"Ceux qui finissent de la 2ème à la 10ème place chaque semaine recevront également des prix en espèces dans leur compte Betway. Voir la section 'Règles' pour les montants exacts que vous pouvez gagner.",

	"common.modal.pointsFormat": "+{points}pts",

	//Betway Account Fragment
	"betwayAccount.title": "Ouvrir un compte Betway",
	"betwayAccount.description":
		"Vous n'avez pas besoin d'avoir un compte Betway pour jouer à BW ScorePredict, cependant pour récupérer un prix hebdomadaire en finissant dans le Top 10 d'une semaine, vous devez avoir un compte Betway pour que ces gains y soient déposés.",
	"betwayAccount.rulesText": "Voir les Règles et CGU du jeu pour les détails des prix hebdomadaires et globaux.",
	"betwayAccount.button": "Ouvrir un compte Betway",
};
